export default class Pagination {
  search: string | null
  page: number
  rowsPerPage: number
  keysToSearch: Array<string>
  constructor({ page, per_page, }: {page: number, per_page: number}, search: string, keyToSearch: Array<string>) {
    this.keysToSearch = keyToSearch;
    this.page = page;
    this.rowsPerPage = per_page;
    if (search !== null && search !== '') {
      this.search = search;
    } else {
      this.search = '';
    }
  }

  toQueryString(): string {
    let querySearch = '';
    this.search && this.keysToSearch.forEach(value => {
      querySearch += `&${value}=${this.search}`;
    });
    return `&page=${this.page}&per_page=${this.rowsPerPage}${querySearch}&sort=created_at desc`;
  }
}
